import { createRouter, createWebHistory } from "vue-router";
import { getToken } from "@/utils/auth";

const whiteList = [
  "/login",
  "/register",
  "/reset",
  "/map",
  "/checkdisk",
  "/contract/details",
];

const routes = [
  {
    path: "/",
    name: "noAuth",
    component: () => import("../views/noAuth.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/index.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/oldHome",
    name: "oldHome",
    component: () => import("../views/oldHome.vue"),
  },
  {
    path: "/newHome",
    name: "newHome",
    component: () => import("../views/newHome.vue"),
  },
  {
    path: "/contract/list",
    name: "ContractList",
    component: () => import("../views/contract/List.vue"),
  },
  {
    path: "/contract/add",
    name: "ContractAdd",
    component: () => import("../views/contract/Add.vue"),
  },
  {
    path: "/contract/details",
    name: "ContractDetails",
    component: () => import("../views/contract/newDetails.vue"),
  },
  {
    path: "/contract/bill",
    name: "ContractBill",
    component: () => import("../views/contract/bill.vue"),
  },
  {
    path: "/contractChange/list",
    name: "ContractChangeList",
    component: () => import("../views/contractChange/list.vue"),
  },
  {
    path: "/contractChange/add",
    name: "ContractChangeAdd",
    component: () => import("../views/contractChange/add.vue"),
  },
  {
    path: "/contractChange/detail",
    name: "ContractChangeDetail",
    component: () => import("../views/contractChange/detail.vue"),
  },
  {
    path: "/forceDelete/list",
    name: "ForceDeleteList",
    component: () => import("../views/forceDelete/list.vue"),
  },
  {
    path: "/components/annexPage",
    name: "annexPage",
    component: () => import("../views/components/annexPage.vue"),
  },
  {
    path: "/model/list",
    name: "ModeltList",
    component: () => import("../views/model/List.vue"),
  },
  {
    path: "/model/addAndEdit",
    name: "ModelAddAndEdit",
    component: () => import("../views/model/AddAndEdit.vue"),
  },
  {
    path: "/model/detail",
    name: "ModelDetail",
    component: () => import("../views/model/Detail.vue"),
  },
  {
    path: "/device/list",
    name: "DeviceList",
    component: () => import("../views/device/List.vue"),
  },
  {
    path: "/device/addAndEdit",
    name: "DeviceAddAndEdit",
    component: () => import("../views/device/AddAndEdit.vue"),
  },
  {
    path: "/device/detail",
    name: "DeviceDetail",
    component: () => import("../views/device/Detail.vue"),
  },
  {
    path: "/receipt/add",
    name: "PaymentAdd",
    component: () => import("../views/receipt/add.vue"),
  },
  {
    path: "/receipt/detail",
    name: "PaymentDetail",
    component: () => import("../views/receipt/Detail.vue"),
  },
  {
    path: "/entry/add",
    name: "EntryOrderAdd",
    component: () => import("../views/entryOrder/Add.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/entry/list",
    name: "EntryOrderList",
    component: () => import("../views/entryOrder/List/index.vue"),
  },
  {
    path: "/entry/details",
    name: "EntryOrderDetails",
    component: () => import("../views/entryOrder/Details.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/checkdisk",
    name: "checkDisk",
    component: () => import("../views/entryOrder/checkDisk.vue"),
  },
  {
    path: "/quit/list",
    name: "QuitOrderList",
    component: () => import("../views/quitOrder/List/index.vue"),
  },
  {
    path: "/quit/details",
    name: "QuitOrderDetails",
    component: () => import("../views/quitOrder/Details.vue"),
  },
  {
    path: "/quit/add",
    name: "QuitOrderAdd",
    component: () => import("../views/quitOrder/Add.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/checkInfo/list",
    name: "CheckInfo",
    component: () => import("../views/checkInfo/list.vue"),
  },
  {
    path: "/renter/listBackup",
    name: "RenterList2",
    component: () => import("../views/renter/listBackup.vue"),
  },
  {
    path: "/renter/list",
    name: "RenterList",
    component: () => import("../views/renter/List.vue"),
  },
  {
    path: "/renter/userBackup",
    name: "RenterUser2",
    component: () => import("../views/renter/userBackup.vue"),
  },
  {
    path: "/renter/user",
    name: "RenterUser",
    component: () => import("../views/renter/User.vue"),
  },
  {
    path: "/renter/userDetail",
    name: "UserDetail",
    component: () => import("../views/renter/Detail.vue"),
  },
  {
    path: "/approval/list",
    name: "ApprovalAdd",
    component: () => import("../views/approval/List.vue"),
  },
  {
    path: "/submit/list",
    name: "SubmitAdd",
    component: () => import("../views/submit/List.vue"),
  },
  {
    path: "/carbonCopy",
    name: "carbonCopy",
    component: () => import("../views/carbonCopy/index.vue"),
  },
  {
    path: "/store/ListBackup",
    name: "StoreList",
    component: () => import("../views/store/ListBackup.vue"),
  },
  {
    path: "/store/list",
    name: "StoreList2",
    component: () => import("../views/store/List.vue"),
  },
  {
    path: "/authToUser/list",
    name: "UserList",
    component: () => import("../views/authToUser/List.vue"),
  },
  {
    path: "/sendSignTask",
    name: "sendSignTask",
    component: () => import("../views/sendSignTask/index.vue"),
  },
  {
    path: "/abolishSignTask",
    name: "abolishSignTask",
    component: () => import("../views/abolishSignTask/index.vue"),
  },
  {
    path: "/overview",
    name: "overview",
    component: () => import("../views/overview/index.vue"),
  },
  {
    path: "/advertisement/iot",
    name: "advertisement",
    component: () => import("../views/advertisement/iot.vue"),
  },
  {
    path: "/todoTask",
    name: "todoTask",
    component: () => import("../views/todoTask/index.vue"),
  },
  {
    path: "/finishedTask",
    name: "finishedTask",
    component: () => import("../views/finishedTask/index.vue"),
  }, {
    path: "/mine",
    name: "mine",
    component: () => import("../views/mine/index.vue"),
  },
  {
    path: "/shopping/list",
    name: "shopping",
    component: () => import("../views/shopping/List.vue"),
  },
  {
    path: "/shopping/detail",
    name: "shopDetail",
    component: () => import("../views/shopping/Detail.vue"),
  },
  {
    path: "/shopping/address",
    name: "address",
    component: () => import("../views/shopping/Address.vue"),
  },
  {
    path: "/shopping/order",
    name: "order",
    component: () => import("../views/shopping/Order.vue"),
  },
  {
    path: "/verified",
    name: "verified",
    component: () => import("../views/verified/index.vue"),
  },

  // 结算/对账
  {
    path: "/settleBill/list",
    name: "settleBillList",
    component: () => import("../views/settleBill/list.vue"),
  },
  {
    path: "/settleBill/add",
    name: "addSettleBill",
    component: () => import("../views/settleBill/add.vue"),
  },
  {
    path: "/settleBill/index",
    name: "index",
    component: () => import("../views/settleBill/index.vue"),
  },
  {
    path: "/settleBill/detail",
    name: "settleDetail",
    component: () => import("../views/settleBill/detail.vue"),
  },
  {
    path: "/billList/list",
    name: "billList",
    component: () => import("../views/billList/list.vue"),
  },
  {
    path: "/billList/add",
    name: "addBill",
    component: () => import("../views/billList/add.vue"),
  },
  {
    path: "/billList/detail",
    name: "billDetail",
    component: () => import("../views/billList/detail.vue"),
  },
  {
    path: "/settleUp/list",
    name: "setUpList",
    component: () => import("../views/settleUp/list.vue"),
  },
  {
    path: "/settleUp/add",
    name: "addSettleUp",
    component: () => import("../views/settleUp/add.vue"),
  },
  {
    path: "/settleUp/detail",
    name: "settleUpDetail",
    component: () => import("../views/settleUp/detail.vue"),
  },
  {
    path: "/devStop/list",
    name: "devStopList",
    component: () => import("../views/devStop/list.vue"),
  },
  {
    path: "/devStop/add",
    name: "devStopEdit",
    component: () => import("../views/devStop/add.vue"),
  },
  {
    path: "/devStop/detail",
    name: "devStopDetail",
    component: () => import("../views/devStop/detail.vue"),
  },
  {
    path: "/claim/list",
    name: "claimList",
    component: () => import("../views/claim/list.vue"),
  },
  {
    path: "/claim/add",
    name: "claimEdit",
    component: () => import("../views/claim/add.vue"),
  },
  {
    path: "/claim/detail",
    name: "claimDetail",
    component: () => import("../views/claim/detail.vue"),
  },

  {
    path: "/invoice/list",
    name: "invoiceList",
    component: () => import("../views/invoice/list.vue"),
  },
  {
    path: "/invoice/add",
    name: "invoiceEdit",
    component: () => import("../views/invoice/add.vue"),
  },
  {
    path: "/invoice/detail",
    name: "invoiceDetail",
    component: () => import("../views/invoice/detail.vue"),
  },
  // 转租管理----------------
  {
    path: "/subLeaseMng/subLesor",
    name: "subLeaseList",
    component: () => import("../views/subLeaseMng/subLesor/list.vue"),
  },
  // 转租记录
  {
    path: "/subLeaseMng/subRecordList",
    name: "subRecordList",
    component: () => import("../views/subLeaseMng/subRecord/list.vue"),
  },
  {
    path: "/subLeaseMng/addSubRecord",
    name: "subRecordAdd",
    component: () => import("../views/subLeaseMng/subRecord/add.vue"),
  },
  {
    path: "/subLeaseMng/subRecordDetail",
    name: "subRecordDetail",
    component: () => import("../views/subLeaseMng/subRecord/detail.vue"),
  },
  // 转租设备
  {
    path: "/subLeaseMng/subDeviceList",
    name: "subDeviceList",
    component: () => import("../views/subLeaseMng/subDevice/list.vue"),
  },
  // 转租报停
  {
    path: "/subLeaseMng/subStopList",
    name: "subStopList",
    component: () => import("../views/subLeaseMng/subStop/list.vue"),
  },
  {
    path: "/subLeaseMng/subStopDetail",
    name: "subStopDetail",
    component: () => import("../views/subLeaseMng/subStop/detail.vue"),
  },
  {
    path: "/subLeaseMng/subStopAdd",
    name: "subStopAdd",
    component: () => import("../views/subLeaseMng/subStop/add.vue"),
  },
  // 转租应付
  {
    path: "/subLeaseMng/subPayList",
    name: "subPayList",
    component: () => import("../views/subLeaseMng/subPay/list.vue"),
  },
  {
    path: "/subLeaseMng/subPayDetail",
    name: "subPayDetail",
    component: () => import("../views/subLeaseMng/subPay/detail.vue"),
  },
  {
    path: "/subLeaseMng/subPayAdd",
    name: "subPayAdd",
    component: () => import("../views/subLeaseMng/subPay/add.vue"),
  }

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (getToken()) {
    if (to.path === "/login") {
      next({ path: "/home" });
    } else {
      next();
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next("/login");
    }
  }
});

export default router;
